import React from 'react';
import AdminLayout from '../components/AdminLayout';

const AdminPricing: React.FC = () => {
  return (
    <AdminLayout>
      <div className="p-8">
        <h1 className="text-3xl font-bold text-gray-900 mb-2">Manage Pricing</h1>
        <p className="text-gray-600">Update pricing plans and packages</p>
      </div>
    </AdminLayout>
  );
};

export default AdminPricing;
